var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlacePin = function SvgPlacePin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1B7E7E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.208 9.167c0 3.333-5.209 6.875-5.209 6.875S4.791 12.5 4.791 9.167c0-2.917 2.447-5.209 5.208-5.209 2.762 0 5.209 2.292 5.209 5.209Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1B7E7E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.875 9.167a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Z"
  })));
};
export { SvgPlacePin as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBhdGggZD0iTTE1LjIwOCA5LjE2N2MwIDMuMzMzLTUuMjA5IDYuODc1LTUuMjA5IDYuODc1UzQuNzkxIDEyLjUgNC43OTEgOS4xNjdjMC0yLjkxNyAyLjQ0Ny01LjIwOSA1LjIwOC01LjIwOSAyLjc2MiAwIDUuMjA5IDIuMjkyIDUuMjA5IDUuMjA5WiIgc3Ryb2tlPSIjMUI3RTdFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PHBhdGggZD0iTTExLjg3NSA5LjE2N2ExLjg3NSAxLjg3NSAwIDEgMS0zLjc1IDAgMS44NzUgMS44NzUgMCAwIDEgMy43NSAwWiIgc3Ryb2tlPSIjMUI3RTdFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+";